import generateAdmitcardActions from "./action";

const initialState = {
    Externalcourselist: null,
    Bulkadmitcardcount: null,
    Admitcardbatchstatus: null
};

const generateAdmitcardReducer = (state = initialState, action) => {
    switch (action.type) {
       case generateAdmitcardActions.SET_EXTERNAL_COURSE:
             return {
               ...state,
               Externalcourselist: action.payload,
             };
       case generateAdmitcardActions.SET_BULK_ADMITCARD_COUNT:
             return {
               ...state,
               Bulkadmitcardcount: action.payload,
             };
       case generateAdmitcardActions.SET_ADMIT_CARD_BATCH_STATUS:
             return {
               ...state,
               Admitcardbatchstatus: action.payload,
             };
        default:
            return state;
    }
};

export default generateAdmitcardReducer;

